export const isCmsPages = () => {
  return window.location.pathname.startsWith('/pages');
};

/** Our Firebase email-action handler — the custom action URL set in the Firebase console must point here. */
export const AUTH_ACTION_PATH = '/auth/action';

export const isAuthActionPage = () => {
  return window.location.pathname === AUTH_ACTION_PATH;
};

/** Pages that render without signing the player in (no geoblock, no profile). */
export const isAuthExemptPage = () => {
  return isCmsPages() || isAuthActionPage();
};
